import _ from 'underscore';
import $ from 'jquery';

export default class Users {
  constructor($scope, UserService, UiService, PaginationService) {
    $scope.users = [];
    $scope.pagination = {};
    $scope.user_types = UserService.get_user_types();
    $scope.user_groups = window.user_groups;
    $scope.offer_campaign_criteria_statuses = window.offer_campaign_criteria_statuses;
    $scope.categories = window.categories;
    $scope.business_relations = window.business_relations;

    $scope.date_options = UiService.date_options();
    $scope.select2_options = UiService.select2_options(600);

    $scope.init_filter = this.init_filter.bind(this);
    $scope.load_data = this.load_data.bind(this);
    $scope.quick_search = this.quick_search.bind(this);
    $scope.$watch('continent', this.update_countries.bind(this));

    this.$scope = $scope;
    this.UserService = UserService;
    this.PaginationService = PaginationService;

    this.init_filter();
    this.load_data();
  }

  init_filter() {
    this.$scope.filter = {
      page: 1,
      per_page: 50,
      user_id: null,
      user_type: null,
      user_groups: [],
      date_from: null,
      date_to: null,
      has_preferences: null,
      has_orders: null,
      contacts: null,
      countries: [],
      is_deleted: false,
      offer_campaign_criteria: null,
      product_category_id: null,
      business_relation: null,
    };

    this.$scope.continent = null;
  }

  update_countries() {
    this.$scope.countries = [];

    if (_.isEmpty(this.$scope.continent)) {
      return;
    }

    var group = $('select#countries').find(
      'optgroup[label="' + this.$scope.continent + '"]'
    );

    group.find('option').each((index, element) => {
      this.$scope.countries.push($(element).attr('value'));
    });
  }

  quick_search() {
    window.filter_table('table.data', this.$scope.quick_filter);
  }

  load_data() {
    this.$scope.filter.user_groups = _.pluck(
      _.where(this.$scope.user_groups, {checked: true})
    , 'id');

    this.UserService.search(this.$scope.filter)
      .then((data) => {
        this.$scope.users = data.users;
        this.$scope.pagination = this.PaginationService.get_pagination(data.pagination);
      });
  }
}

Users.$inject = ['$scope', 'UserService', 'UiService', 'PaginationService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/users.ctrl.js